import {
  DashboardDTO,
  DashboardVariableDTO,
  DashboardVariableValuesDTO,
} from '@/entities/dashboards/dashboard/@x/dashboard-tab';
import { TemplateDTO } from '@/entities/dashboards/dashboard-widget';
import { z } from 'zod/v4';

// ======================== Helper Types ========================

export const DashboardRangeTypeDTO = z.union([
  z.tuple([z.string(), z.string()]),
  z.number(),
]);
export type DashboardRangeType = z.infer<typeof DashboardRangeTypeDTO>;
export const TabConfigDTO = TemplateDTO.extend({
  variables: z.array(DashboardVariableDTO).optional(),
  variable_values: DashboardVariableValuesDTO.optional(),
});
export type TabConfig = z.infer<typeof TabConfigDTO>;
// ======================== DashboardTab DTO ========================
export const DashboardTabDTO = z
  .object({
    dashboard_id: z.string(),
    deleted_at: z.string().nullish(),
    can_edit: z.boolean().nullish(),
    dashboard_update: z.string().nullish(),
    layout: z
      .object({
        ts: z.number(),
        items: z.array(z.string()),
      })
      .partial()
      .nullish(),
  })
  .extend(
    DashboardDTO.omit({
      tags: true,
      private_for_user_id: true,
      name: true,
      variables: true,
      config: true,
    }).shape,
  )
  .extend({ config: TabConfigDTO.nullish() });
export type DashboardTab = z.infer<typeof DashboardTabDTO>;

// ======================== Derived DTOs ========================
export const DashboardTabBriefDTO = DashboardTabDTO.pick({
  id: true,
  title: true,
  deleted_at: true,
  layout: true,
}).extend({
  dashboard_update: z.string().nullish(),
});
export type DashboardTabBrief = z.infer<typeof DashboardTabBriefDTO>;

export const CreateTabDTO = DashboardTabDTO.omit({
  id: true,
  deleted_at: true,
});
export type CreateTab = z.infer<typeof CreateTabDTO>;

export const UpdateTabDTO = DashboardTabDTO.omit({
  deleted_at: true,
}).partial();
export type UpdateTab = z.infer<typeof UpdateTabDTO>;

export const CreateDashboardTabDTO = DashboardTabDTO.omit({
  id: true,
  query_id: true,
  deleted_at: true,
  config: true,
  widgets: true,
  ci_type_bindings: true,
})
  .extend({
    dashboard_name: z.string(),
  })
  .omit({ dashboard_id: true });
export type CreateDashboardTab = z.infer<typeof CreateDashboardTabDTO>;